import React from 'react';
import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import dayjs from 'dayjs';
// import { Grid2, Typography } from '@mui/material';



const borderColor = 'white'
const stylesTH = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderBottomColor: 'white',
        backgroundColor: 'black',
        color: 'white',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 15,
        textAlign: 'center',
        flexGrow: 1,
        fontSize: '7px',
    },
    thdescription: {
        width: '60%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    thamount: {
        width: '40%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
});

// Table Row
const stylesTR = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: 'black',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 'auto',
        textAlign: 'center',
        flexGrow: 1,
        fontSize: 6
    },
    trdescription: {
        width: '60%',
        height: '100%',
        textAlign: 'left',
        paddingLeft: 4,
        fontWeight: 'bolder',
        fontSize: 10
    },
    tramount: {
        width: '40%',
        height: '100%',
        textAlign: 'right',
        paddingLeft: 8,
        fontWeight: 'bolder',
        fontSize: 10
    },
});


//   Table Container
const stylesTC = StyleSheet.create({
    tableContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: 10,
        marginLeft: 10,
        marginRight: 10,
        borderWidth: 1,
        borderColor: 'black',
        fontSize: '7px',
    },
});

const SalesInvoicePDF = ({ closingData, user }) => (
    <>
        <PDFViewer width={500} height={400} style={{ border: 'none' }}>
            <Document>
                <Page size={{
                    width: 2.8 * 72, height: 5 * 72
                }}>
                    <View>
                        {/* <Image style={{ height: '80px', width: '80px', alignSelf: 'center' }} src={user.cmpImage} /> */}
                        <View style={{ marginLeft: '10px' }}>
                            <Text style={{ fontSize: '15px', textAlign: 'center' }}>{user.cmpName}</Text>
                            <Text style={{ fontSize: '9px' }}>{user.cmpAddress}</Text>
                            <Text style={{ fontSize: '9px' }}>---</Text>
                        </View>
                    </View>
                    <View>
                        <Text style={{ fontSize: '12px', fontWeight: 'bold', textAlign: 'center' }}>Closing Detail</Text>
                    </View>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginLeft: '5px', marginRight: '5px', marginTop: 5 }}>
                        <Text style={{ fontSize: '8px', fontWeight: 'bold', textAlign: 'left' }}>EntDate : {dayjs(closingData && closingData.length > 0 && closingData[0].entDate).format('DD-MMM-YYYY')}</Text>
                    </View>
                    <View>
                        <Text style={{ marginLeft: '5px', fontSize: '8px', textAlign: 'left' }}>User : {user.dispName} , ID : {user.userName}</Text>
                        {/* <Text style={{ marginLeft: '5px', fontSize: '10px', textAlign: 'left' }}>Customer Name : {salesMaster && salesMaster.length > 0 && salesMaster[0].custName}</Text> */}
                    </View>
                    <View style={stylesTC.tableContainer}>
                        <View style={stylesTH.container}>
                            <Text style={stylesTH.thdescription}>Description</Text>
                            <Text style={stylesTH.thamount}>Value</Text>
                        </View>
                        {closingData && closingData.length > 0 && closingData[0].msg !== 'Not Found' && closingData.map((item, index) => (
                            <View style={stylesTR.row} key={item.RONO || index}>
                                {/* <Text style={stylesTR.trsno}>{index + 1}</Text> */}
                                <Text style={{
                                    ...stylesTR.trdescription,
                                    fontSize: `${index === closingData.length - 1 ? 13 : 10}`,
                                    backgroundColor: `${index === closingData.length - 1 ? 'black' : 'white'}`,
                                    color: `${index === closingData.length - 1 ? 'white' : 'black'}`,
                                    fontWeight: `${index === closingData.length - 1 ? 'bold' : 'normal'}`,
                                }}>{item.saleType}</Text>
                                <Text style={{
                                    ...stylesTR.tramount,
                                    fontSize: `${index === closingData.length - 1 ? 13 : 10}`,
                                    backgroundColor: `${index === closingData.length - 1 ? 'black' : 'white'}`,
                                    color: `${index === closingData.length - 1 ? 'white' : 'black'}`,
                                    fontWeight: `${index === closingData.length - 1 ? 'bold' : 'normal'}`,
                                }}>{Math.round(item.totalAmount).toLocaleString("en-US")}</Text>
                            </View>))}
                    </View>
                    <View>
                        <View style={{ marginLeft: '10px', marginTop: 5 }}>
                            <Text style={{ fontSize: '8px', fontWeight: 'bold' }}>Developed By : World Home Development</Text>
                            <Text style={{ fontSize: '7px' }}>web. whdevs.com | Cont. 0335-2220730</Text>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    </>
);

export default SalesInvoicePDF;
